import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../shared/scripts/table-column-visibility";
import {
    GetSelectedDropdownValues,
    IFilter,
    InitializeFilterDropdown,
    InitializeFilterOptGroupDropdown,
    DropdownOptGroup
} from "../../shared/scripts/dropdown-functions";
import { getDisplayDate, FormatDate } from "../../shared/scripts/date-functions";
import { DoArraysOverlap } from "../../shared/scripts/array-functions";
import _ from 'lodash';
import { EditManuscriptsPage } from "../manuscript-tracker/scripts/edit-manuscripts.page";
import 'highcharts'
//import Highcharts from "highcharts";

// Notes:
// CHART OFF(Phase 2): re-enable wireMsChartToggle() + reflow block when chart is ready

// --- VM from model ---

export interface PublicationsVm {
    TargetJournal: string;
    PubMedId: string;
    Doi: string;
    Pmcid: string;
}

// Server-precomputed filters
export interface CoreProjGroupVm {
    Center: string;
    Tokens: string[];
}
export interface FiltersVm {
    Statuses: string[];
    Centers: string[];
    CollaboratingCenters: string[];
    PrimaryAuthors: string[];
    SeniorAuthors: string[];
    NetworkAuthors: string[];
    Journals: string[];
    CoreProjectByCenter: CoreProjGroupVm[];
}
export interface PageVm {
   // Items: ManuscriptVm[];
    Filters: FiltersVm;
}
export interface ManuscriptTrackerPageVm {
    //items: ManuscriptVm[];
    filters: FiltersVm;

    publications: CenterPublicationRowVm[];
    publicationsLastUpdatedUtc?: string; // ISO string
    inProgressMsByCenter?: Record<string, number>; // In progress manuscripts count

}

export interface CenterPublicationRowVm {
    // single convenience fields 
    CenterId?: number;
    CenterName?: string;
    AwardNumber?: string;

    // Multi fields (preferred)
    CenterIds?: number[] | null;
    CenterNames?: string[] | null;
    AwardNumbers?: string[] | null;

    FundingGrants?: string[] | null;

    PubMedId?: string;
    Title?: string;
    Authors?: string;
    PubYear?: number | null;

    Journal?: string;
    Abstract?: string;
    Doi?: string;

    MeshTerms?: string[] | null;
    Keywords?: string[] | null;

    PublicationDateUtc?: string | null;
    IsPreprint?: boolean;

    MatchKey?: string | null;

}
type PubDtRow = {
    // multi
    CenterNames: string[];
    AwardNumbers: string[];
    FundingGrants: string[];

    // display-friendly
    CenterNameJoined: string;
    AwardNumberJoined: string;
    FundingGrantsJoined: string;

    // bib
    PubMedId: string;
    Title: string;
    Authors: string;
    AuthorsList : string [];
    PubYear: number | null;

    Journal: string;
    JournalNorm: string;
    PublicationDateUtc: string;
    PublicationDateDisplay: string;

    Doi: string;
    Pmcid: string;
    Abstract: string;

    MeshTerms: string[];
    MeshTermsJoined: string;
    Keywords: string[];
    IsPreprint: boolean;
    MatchKey: string;

};



type Input = string | ManuscriptTrackerPageVm | PageVm | { Filters?: FiltersVm };


const EmptyDisplay = '-none-';

type MsInnerTab = 'overview' | 'authors';

const MISSING_AWARD_LABEL = 'Missing award (update on PubMed)';
const MISSING_CENTER_LABEL = '-- Unknown --';

export class ManuscriptTrackerPage {
    //Rows for Pub and filters
    private pubsRowsAll: PubDtRow[] = [];

    private pubsFiltersInited = false;


  
    private filters?: FiltersVm;

   

    private editMsInited = false;
    private editMsPage?: EditManuscriptsPage;


    private publications: CenterPublicationRowVm[] = [];

    private inProgressMsByCenter: Record<string, number> = {};

    constructor(input: Input) {
        const { filters, publications, inProgressMsByCenter } = this.parseInput(input);
       // this.items = items;
        this.filters = filters;
        this.publications = publications ?? [];
        this.inProgressMsByCenter = inProgressMsByCenter ?? {};

        //update time on load
        const el = document.getElementById('pubs-last-updated');
        const utc = el?.getAttribute('data-utc');

        if (el && utc) {
            el.textContent = this.formatLocalRazorStyle(new Date(utc));
            el.classList.remove('d-none');
        }

    
        this.wireSimpleTooltips();    

        //V2. Call for chart toggle
        //this.wireMsChartToggle();
        this.wireTopTabs();

        // init the active top tab module once on load
        requestAnimationFrame(() => {
            if ($('#pubs-tab').hasClass('active') || $('#pubs-pane').hasClass('active')) {
                this.ensurePublicationsModule();
            }
        });

    }


    // --- Parse input ---
    private parseInput(input: any): {
        filters?: FiltersVm; publications?: CenterPublicationRowVm[]; publicationsLastUpdatedUtc?: string; publicationsDebug?: string; inProgressMsByCenter?: Record<string, number>; } {
        const normalize = (obj: any) => ({
            items: obj?.Items ?? obj?.items ?? [],
            filters: obj?.Filters ?? obj?.filters,
            publications: obj?.Publications ?? obj?.publications ?? [],
            publicationsLastUpdatedUtc: obj?.PublicationsLastUpdatedUtc ?? obj?.publicationsLastUpdatedUtc,
            publicationsDebug: obj?.PublicationsDebug ?? obj?.publicationsDebug,
            inProgressMsByCenter: obj?.InProgressMsByCenter ?? obj?.inProgressMsByCenter ?? {}

        });

        if (typeof input === "string") {
            try { return normalize(JSON.parse(input)); }
            catch (e) { console.error("Failed to parse ManuscriptsJson", e); return ; }
        }

        return normalize(input);
    }

    // --- Helpers reused by filters/CSV ---

    private isAllSelected(selectId: string, selected: string[] | null | undefined): boolean {
        if (!selected || !selected.length) return false;

        const options = document.querySelectorAll<HTMLOptionElement>(`${selectId} option`);
        const uniqueValues = new Set(Array.from(options, o => o.value));

        if (uniqueValues.size === 0) return false;

        const selectedSet = new Set(selected);
        for (const v of uniqueValues) {
            if (!selectedSet.has(v)) return false;
        }
        return true;
    }

    private readSel(selectId: string): string[] | null {
        const $el = $(selectId);
        if ($el.length === 0) return null;

        if ($el.find('option').length === 0) return null;

        const raw = GetSelectedDropdownValues(selectId) as string[] | null;
        const sel = raw ?? [];

        // none selected => match nothing
        if (sel.length === 0) return [];

        // all selected => treat as no filter
        if (this.isAllSelected(selectId, sel)) return null;

        return sel;
    }


    private matchesOne(sel: string[] | null, value?: string): boolean {
        if (sel == null) return true;     // no filter
        if (sel.length === 0) return false; // match nothing
        return value ? sel.includes(value) : false;
    }

    private matchesAny(sel: string[] | null, values?: string[]): boolean {
        if (sel == null) return true;
        if (sel.length === 0) return false;
        return DoArraysOverlap(sel, (values ?? []).filter(Boolean));
    }

    // ==============================
    // CSV Export
    // ==============================

    private buildCsv(headers: string[], rows: string[][]) {
        const esc = (s: any) => `"${String(s).replace(/"/g, '""')}"`;
        return '\uFEFF' + [headers.map(esc).join(','), ...rows.map(r => r.map(esc).join(','))].join('\r\n');
    }

    private downloadCsv(csv: string, filename: string) {
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
    }

    // --- CSV for Publications
    private exportCsvForVisiblePublications(dt: DataTables.Api, baseName: string) {
        const rows = dt.rows({ search: 'applied', page: 'all' }).data().toArray() as PubDtRow[];

        const V = (x: unknown) => (x == null ? '' : String(x).trim());
        const L = (arr: any) =>
            (Array.isArray(arr) ? arr : [])
                .map((s: any) => V(s))
                .filter(Boolean)
                .join('; ');

        const H = [
            'Title',
            'Authors',
            'Journal',
            'Award Number',
            'Publication Date',
            'Centers',
            'Abstract',
            'MeSH Terms',
            'PMID',
            'PMCID',
            'DOI',
            'Preprint',
            'Funding / Grants',

        ];

        const data = rows.map(r => ([
            V(r.Title),
            V(r.Authors),
            V(r.Journal),
            V(r.AwardNumberJoined),

            V(r.PublicationDateDisplay || r.PublicationDateUtc),
            V(r.CenterNameJoined),
            V(r.Abstract),
            V(r.MeshTermsJoined) ,
            V(r.PubMedId),
            V(r.Pmcid),
            V(r.Doi),
            r.IsPreprint ? 'Yes' : 'No',
            V(r.FundingGrantsJoined),


        ]));

        const csv = this.buildCsv(H, data);
        const today = new Date().toISOString().slice(0, 10);
        this.downloadCsv(csv, `${baseName}_${today}.csv`);
    }

  

    // ==============================
    // Modal Helper- PILLS
    // ==============================

    private renderPills($host: JQuery, items: string[]) {
        const pillClass = ($host.attr('data-pill-class') || 'pill').trim();
        $host.empty();

        const clean = (items || []).filter(x => x && x.trim().length);
        if (!clean.length) {
            $host.text(EmptyDisplay);
            return;
        }

        clean.forEach(txt => {
            const $pill = $('<span/>', { class: pillClass }).append(
                $('<span/>', { text: txt })
            );
            $host.append($pill);
        });
    }


    // ==============================
    // Publications top tabs
    // ==============================

    // Nav Publications + publications Panes
    private wireTopTabs(): void {
        const sel = '#ms-top-tabs a[data-toggle="tab"]';
        $(sel).off('shown.bs.tab').on('shown.bs.tab', (e) => {
            const href = ($(e.target).attr('href') || '').toLowerCase();

            if (href === '#pubs-pane') {
                this.ensurePublicationsModule();
                // V2. Reflow chart after container is visible again
               // setTimeout(() => {
                   // try { (Highcharts as any).charts?.forEach((c: any) => c && c.reflow && c.reflow()); } catch { }
                //}, 0);

            }
            if (href === '#edit-ms-pane') this.ensureEditManuscriptsModule();

        });
    }


    // ==============================
    // Ensure Edit Manuscripts Partial
    // ==============================

    private ensureEditManuscriptsModule(): void {
        if (this.editMsInited) {
            try { (this.editMsPage?.manuscriptsTable as any)?.resizeTable?.(); } catch { }
            return;
        }

        this.editMsPage = new EditManuscriptsPage();
        this.editMsPage.initEditPane();


        (this as any).manuscriptsTable = this.editMsPage.manuscriptsTable;

        setTimeout(() => {
            try { (this.editMsPage?.manuscriptsTable as any)?.resizeTable?.(); } catch { }
        }, 0);

        this.editMsInited = true;
    }
 

    // ==============================
    // Publications Module
    // ==============================
    private mapToPubDtRows(pubs: any[] | null | undefined): PubDtRow[] {
        // Small, reusable normalizers
        const S = (v: any): string => String(v ?? '').trim();
        const A = (v: any): string[] => (Array.isArray(v) ? v : []).map(S).filter(Boolean);
        const J = (arr: string[]) => arr.join('; ');

        return (pubs ?? []).map((p: any) => {
            const centerNames = A(p.CenterNames ?? p.centerNames);
            const awardNumbers = A(p.AwardNumbers ?? p.awardNumbers);
            const funding = A(p.FundingGrants ?? p.fundingGrants);
            const mesh = A(p.MeshTerms ?? p.meshTerms);
            const keywords = A(p.Keywords ?? p.keywords);

            const pubDateUtc = S(p.PublicationDateUtc ?? p.publicationDateUtc);
            const pubDateDisplay = pubDateUtc ? getDisplayDate(new Date(pubDateUtc)) : '';

            const centerSingle = S(p.CenterName ?? p.centerName);
            const awardSingle = S(p.AwardNumber ?? p.awardNumber);

            const centerFinal =
                (centerNames.length ? centerNames : (centerSingle ? [centerSingle] : [MISSING_CENTER_LABEL]));

            const awardFinal =
                (awardNumbers.length ? awardNumbers : (awardSingle ? [awardSingle] : [MISSING_AWARD_LABEL]));

            const authorsStr = S(p.Authors ?? p.authors);
            const authorsList = authorsStr
                ? authorsStr.split(';').map(x => x.trim()).filter(Boolean)
                : [];

            const journal = S(p.Journal ?? p.journal);

            return {
                CenterNames: centerFinal,
                AwardNumbers: awardFinal,
                FundingGrants: funding,

                CenterNameJoined: J(centerFinal),
                AwardNumberJoined: J(awardFinal),
                FundingGrantsJoined: J(funding),

                PubMedId: S(p.PubMedId ?? p.pubMedId),
                Title: S(p.Title ?? p.title),

                Authors: authorsStr,
                AuthorsList: authorsList,      // add to PubDtRow type

                PubYear: (p.PubYear ?? p.pubYear ?? null),

                Journal: journal,
                JournalNorm: journal.toLowerCase(), // add to PubDtRow type

                Abstract: S(p.Abstract ?? p.abstract),
                Doi: S(p.Doi ?? p.doi),
                Pmcid: S(p.Pmcid ?? p.pmcid),

                MeshTerms: mesh,
                MeshTermsJoined: J(mesh),

                PublicationDateUtc: pubDateUtc,
                PublicationDateDisplay: pubDateDisplay,

                Keywords: keywords,
                KeywordsJoined: J(keywords),

                IsPreprint: !!(p.IsPreprint ?? p.isPreprint),
                MatchKey: S(p.MatchKey ?? p.matchKey),
            };
        });
    }

    private pubsInited = false;
    private dtPubsStandalone?: DataTables.Api;
    private ensurePublicationsModule(): void {
        if (this.pubsInited) {
            try { this.dtPubsStandalone?.columns.adjust().draw(false); } catch { }
            this.updatePubsCount();
            return;
        }


        // -- Mapping helpers
        const rows: PubDtRow[] = this.mapToPubDtRows(this.publications);



        this.pubsRowsAll = rows;
        this.rebuildPubsIndex(this.pubsRowsAll);
        if (!this.pubsFiltersInited) {
            this.buildPublicationsFilters();
        }

      

        const dom =
            `<"pubs-top-controls d-flex align-items-center justify-content-between"
            <"pubs-search col-md-3 pl-0"f>
            <"pubs-actions"B>
         >r t ip`;

        this.dtPubsStandalone = ($('#pubsTable') as any).DataTable({
            dom,
            paging: false,
            info: false,
            searching: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            fixedColumns: 1,
            //order by publication date
            order: [[4, "desc"], [0, "asc"]],

            deferRender: true,
            data: rows,


            buttons: [{
                text: `<i class="fas fa-file-download"></i>`,
                titleAttr: 'CSV',
                action: (_e: any, api: DataTables.Api) =>
                    this.exportCsvForVisiblePublications(api, 'Revampp-Published-Manuscripts')
            }],
            columns: [
                // Title + preprint badge
                {
                    data: 'Title',
                    className: 'b-fixed-left font-size12 text-left table-column-lg ',
                    title: 'Title',
                    defaultContent: '',
                    render: (d: string, type: string, row: PubDtRow) => {
                        const title = (d || '').trim();
                        if (type !== 'display') return title;

                        const key = this.getPubKey(row);

                        return `
      <a href="#" class="pub-title-link line-height font-weight-500"
         data-pubkey="${_.escape(key)}"
         title="View publication details">
        ${_.escape(title || 'Untitled')}
      </a>`;
                    }

                },
                // Center and Award - Render warning msg and tooltip when missing award number.
                {
                    data: 'CenterNameJoined',
                    className: 'text-left font-size12 table-column-sm',
                    title: 'Center',
                    defaultContent: '',
                    render: (d: string, type: string, row: PubDtRow) => {
                        const v = (d || '').trim();
                        if (type !== 'display') return v;

                        // Center missing because award is missing
                        if (!v || v === MISSING_CENTER_LABEL) {
                            const msg =
                                'This publication has no award number on PubMed, so it cannot be associated with a center. ' +
                                'Add or update funding information on the PubMed record (PMID).';

                            return `
        <span class="text-warning font-italic js-tip"
              data-tooltip="${_.escape(msg)}">
          ${_.escape(MISSING_CENTER_LABEL)}
          <i class=" fas fa-question-circle ml-1"></i>
        </span>`;
                        }

                        return _.escape(v);
                    }
                },
                {
                    data: 'Authors', className: 'text-left font-size12 table-column-lg', title: 'Authors', defaultContent: '',
                    render: (abs?: string, type?: string) => {
                        const v = (abs || '').trim();
                        if (!v) return '';
                        if (type && type !== 'display') return v;
                        const short = v.length > 120 ? v.slice(0, 120) + '…' : v;
                        return `<span title="${_.escape(v)}">${_.escape(short)}</span>`;
                    }
                },

                { data: 'Journal', className: 'text-left font-size12 table-column-md', title: 'Journal', defaultContent: '' },
                {
                    data: 'PublicationDateUtc', //  sort key
                    title: 'Pub Date',
                    className: 'text-left font-size12 table-column-sm',
                    defaultContent: '',
                    render: (_utc?: string, type?: string, row?: PubDtRow) => {
                        const utc = (row?.PublicationDateUtc || '').trim();
                        if (!utc) return '';
                        if (type && type !== 'display') return utc; //  sorting/searching uses UTC
                        return row?.PublicationDateDisplay || utc;
                    }
                },

                // Preprint Col 
                {
                    data: 'IsPreprint',
                    title: 'Preprint',
                    className: 'text-left font-size12 nowrap table-column-xs',
                    defaultContent: '',
                    render: (v?: boolean, type?: string) => {
                        if (type && type !== 'display') return v ? 1 : 0; // numeric sort
                        return v ? 'Yes' : 'No';
                    }
                },

                {
                    data: 'AwardNumberJoined', className: 'text-left font-size12 table-column-sm', title: 'Award Number', defaultContent: '', render: (d: string, type: string) => {
                        const v = (d || '').trim();
                        if (type !== 'display') return v;

                        if (v === MISSING_AWARD_LABEL) {
                            const msg = 'Award number missing in PubMed metadata. Update funding information on the PMID record.';
                            return `
                        <span class="text-warning font-italic js-tip"
                              data-tooltip="${_.escape(msg)}">
                          ${_.escape(v)}
                          <i class="fas fa-question-circle ml-1"></i>
                        </span>`;
                        }


                            return _.escape(v);
                     }
                 },

                {
                    data: 'Abstract',
                    title: 'Abstract',
                    className: 'text-left font-size12 table-column-lg',
                    defaultContent: '',
                    render: (abs?: string, type?: string) => {
                        const v = (abs || '').trim();
                        if (!v) return '';
                        if (type && type !== 'display') return v;
                        const short = v.length > 120 ? v.slice(0, 120) + '…' : v;
                        return `<span title="${_.escape(v)}">${_.escape(short)}</span>`;
                    }
                },

                // PMID link
                {
                    data: 'PubMedId',
                    title: 'PMID',
                    className: 'text-left font-size12 nowrap table-column-sm',
                    defaultContent: '',
                    render: (pmid?: string, type?: string) => {
                        const v = (pmid || '').trim();
                        if (!v) return '';
                        if (type && type !== 'display') return v;
                        return `<a href="https://pubmed.ncbi.nlm.nih.gov/${encodeURIComponent(v)}/" class= "external" target="_blank" rel="noopener">${_.escape(v)}</a>`;
                    }
                },
                {
                    data: 'Pmcid',
                    title: 'PMCID',
                    className: 'text-left font-size12 nowrap table-column-sm',
                    defaultContent: '',
                    render: (pmcid?: string, type?: string) => {
                        const v = (pmcid || '').trim();
                        if (!v) return '';
                        if (type && type !== 'display') return v;

                        // PMCID links can go to PMC
                        return `<a href="https://pmc.ncbi.nlm.nih.gov/articles/${encodeURIComponent(v)}/"
              class="external" target="_blank" rel="noopener">${_.escape(v)}</a>`;
                    }
                },
                {
                    data: 'Doi',
                    title: 'DOI',
                    className: 'text-left font-size12 nowrap table-column-md',
                    defaultContent: '',
                    render: (doi?: string, type?: string) => {
                        const v = (doi || '').trim();
                        if (!v) return '';
                        if (type && type !== 'display') return v;
                        return `<a href="https://doi.org/${encodeURIComponent(v)}" target="_blank" class= "external" rel="noopener">${_.escape(v)}</a>`;
                    }
                },

                {
                    data: 'FundingGrantsJoined',
                    title: 'Funding / Grants',
                    className: 'text-left font-size12 table-column-lg',
                    defaultContent: '',
                },

                // Hidden Mesh and KeyWords ------
                { data: 'MeshTermsJoined', title: 'MeSH', className: 'text-left font-size12 table-column-lg', defaultContent: '', visible: false },

                {
                    data: 'KeywordsJoined',
                    title: 'KeywordsJoined',
                    className: 'text-left font-size12 table-column-lg',
                    defaultContent: '',
                    visible: false

                },
            ]

        }) as DataTables.Api;
        this.wirePublicationsRowActions();

        $(`.pubs-search .dataTables_filter`).addClass('mb-0');
        $(`.pubs-search input[type="search"]`).addClass('form-control form-control-sm');


        this.applyPublicationsFilters();

        $('#pubs-reset').off('click').on('click', () => {

            const dt = this.dtPubsStandalone;
            const prevOrder = dt ? dt.order() : null;
            // Center + Year: select all (no filter)
            const selectAll = (id: string) => {
                const $el = $(id);
                $el.find('option').prop('selected', true);
                try { ($el as any).selectpicker('refresh'); } catch { }
            };

            // Author + Journal: none selected => treat as no filter (readSelNoSelectionMeansAll)
            const deselectAll = (id: string) => {
                try { ($(id) as any).selectpicker('deselectAll'); } catch {
                    // fallback if selectpicker not available
                    $(id).find('option').prop('selected', false);
                }
                try { ($(id) as any).selectpicker('refresh'); } catch { }
            };

            // Preprint: reset to Yes + No
            const setPreprintDefault = () => {
                const $pre = $('#sel-pubs-preprint');
                $pre.find('option').prop('selected', true);   // select Yes + No
                try { ($pre as any).selectpicker('refresh'); } catch { }
            };


            selectAll('#sel-pubs-center');
            selectAll('#sel-pubs-year');
            setPreprintDefault();

            deselectAll('#sel-pubs-author');
            deselectAll('#sel-pubs-journal');

            $('#chk-pubs-haspmid').prop('checked', false);

            // Clear global search and restore default ordering
            this.dtPubsStandalone?.search('');

            this.applyPublicationsFilters();
            if (dt && prevOrder) {
                dt.order(prevOrder).draw(false);
            }
        });

        // Put Author + Journal back to "None Selected" (
        ($('#sel-pubs-author') as any).selectpicker('deselectAll');
        ($('#sel-pubs-journal') as any).selectpicker('deselectAll');
        ($('#sel-pubs-author') as any).selectpicker('refresh');
        ($('#sel-pubs-journal') as any).selectpicker('refresh');

        this.pubsInited = true;
        //V2.Build chart
      
       // this.wireMsChartToggle();

        requestAnimationFrame(() => {
            try { this.dtPubsStandalone?.columns.adjust(); } catch { }
        });

        this.updatePubsCount();
        this.wirePublicationsRefresh();
    }


    //Generates a stable publication ID (best available key).
    private getPubKey(r: Partial<PubDtRow>): string {
        const mk = String(r.MatchKey ?? '').trim();
        if (mk) return mk;

        const pmid = String(r.PubMedId ?? '').trim();
        if (pmid) return `pmid:${pmid}`;


        const title = String(r.Title ?? '').trim().toLowerCase();
        const journal = String(r.Journal ?? '').trim().toLowerCase();
        const year = r.PubYear != null ? String(r.PubYear) : '';
        const doi = String((r as any).Doi ?? '').trim().toLowerCase();
        return `${doi}|${journal}|${year}|${title}`.replace(/\s+/g, ' ');
    }



    // ==============================
    // Pubs Count + Filters
    // ==============================

    private updatePubsCount(): void {
        const dt = this.dtPubsStandalone;
        const count = dt ? dt.rows({ search: 'applied' }).count() : 0;
        $('#pubs-count').text(`${count} Manuscript${count === 1 ? '' : 's'} Found`);
    }

    private pubsIndex = new Map<string, PubDtRow>();
    private rebuildPubsIndex(rows: PubDtRow[]) {
        this.pubsIndex.clear();
        rows.forEach(r => {
            const key = this.getPubKey(r);
            this.pubsIndex.set(key, r);
        });
    }

    private readSelNoSelectionMeansAll(selectId: string): string[] | null {
        const $el = $(selectId);
        if ($el.length === 0) return null;
        if ($el.find('option').length === 0) return null;

        const raw = GetSelectedDropdownValues(selectId) as string[] | null;
        const sel = (raw ?? [])
            .map(s => String(s ?? '').trim())
            .filter(Boolean);

        // none selected => treat as no filter
        if (sel.length === 0) return null;

        // all selected => treat as no filter
        if (this.isAllSelected(selectId, sel)) return null;

        return sel;
    }


    // Pub filters
    private buildPublicationsFilters(): void {
        $('#pubs-filter-container').html(`
    <div class="row no-gutters align-items-end">
      <div class="col px-1">
        <label class="mb-1 font-size12">Center</label>
        <select id="sel-pubs-center" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="All"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Author</label>
        <select id="sel-pubs-author" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="None Selected"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Journal</label>
        <select id="sel-pubs-journal" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="None Selected"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Year</label>
        <select id="sel-pubs-year" class="selectpicker" multiple
                data-actions-box="true" data-live-search="true"
                data-width="100%" title="All"></select>
      </div>

      <div class="col px-1">
        <label class="mb-1 font-size12">Preprint</label>
        <select id="sel-pubs-preprint" class="selectpicker" multiple
                data-actions-box="true"
                data-width="100%" title="All"></select>
      </div>
    </div>
  `);

        const uniq = (arr: string[]) =>
            Array.from(new Set(arr.map(x => (x ?? '').trim()).filter(Boolean)))
                .sort((a, b) => a.localeCompare(b));

        let centers = uniq(
            this.pubsRowsAll.flatMap(r => (r.CenterNames ?? []).map(x => x.trim())).filter(Boolean)
        );

        if (!centers.includes(MISSING_CENTER_LABEL)) centers.push(MISSING_CENTER_LABEL);
        centers = centers.sort((a, b) => a.localeCompare(b));


        const authors = uniq(
            this.pubsRowsAll
                .flatMap(r =>
                    String(r.Authors ?? '')
                        .split(';')
                        .filter(x => x.replace(/[,;]/g, '').trim().length > 0)
                        .map(a => a.trim()|| '- None -')
                        
                )
                   
              
        );

        const journals = uniq(
            this.pubsRowsAll
                .map(r => String((r as any).Journal ?? '').trim())
                .filter(Boolean)
        );

        const years = Array.from(new Set(
            (this.pubsRowsAll as PubDtRow[])
                .map(r => r.PubYear)
                .filter((y): y is number => y != null && String(y).trim() !== '')
                .map(y => String(y))
        )).sort((a, b) => Number(b) - Number(a));

        const preprintOpts = ['Yes', 'No'];

        const trigger = { triggerFilter: () => this.applyPublicationsFilters() };

        InitializeFilterDropdown('#sel-pubs-center', centers, trigger);
        InitializeFilterDropdown('#sel-pubs-author', authors, trigger, undefined, false);
        InitializeFilterDropdown('#sel-pubs-journal', journals, trigger, undefined, false);
        InitializeFilterDropdown('#sel-pubs-year', years, trigger);
        InitializeFilterDropdown('#sel-pubs-preprint', preprintOpts, trigger);

        $('#chk-pubs-haspmid').off('change').on('change', () => this.applyPublicationsFilters());

        this.pubsFiltersInited = true;

        requestAnimationFrame(() => {

            this.applyPublicationsFilters();
        });
    }


    private applyPublicationsFilters(): void {
        const selCenter = this.readSel('#sel-pubs-center');
        const selAuthor = this.readSelNoSelectionMeansAll('#sel-pubs-author');
        const selJournal = this.readSelNoSelectionMeansAll('#sel-pubs-journal');
        const selYear = this.readSel('#sel-pubs-year');
        const selPreprint = this.readSel('#sel-pubs-preprint');

        const hasPmidOnly = $('#chk-pubs-haspmid').is(':checked');

        // Build once so both filters reuse the same parsing
        const passesCommon = (r: PubDtRow) => {
            const rowCenters = (r.CenterNames ?? []).map(x => String(x ?? '').trim()).filter(Boolean);
            const okCenter =
                selCenter == null
                    ? true
                    : (rowCenters.length > 0 && this.matchesAny(selCenter, rowCenters));

            const rowAuthors = r.AuthorsList ?? [];

            const okAuthor = this.matchesAny(selAuthor, rowAuthors);

            const rowJournal = String((r as any).Journal ?? '').trim();
            const okJournal =
                selJournal == null
                    ? true
                    : selJournal.some(j => String(j ?? '').trim().toLowerCase() === rowJournal.toLowerCase());

            const okYear = this.matchesOne(selYear, r.PubYear != null ? String(r.PubYear) : '');

            const okPmid = !hasPmidOnly || !!(r.PubMedId || '').trim();

            return okCenter && okAuthor && okJournal && okYear && okPmid;
        };

        // TABLE rows: include preprint filter 
        const filteredTable = (this.pubsRowsAll ?? []).filter(r => {
            if (!passesCommon(r)) return false;

            const preprintVal = r.IsPreprint ? 'Yes' : 'No';
            const okPreprint = this.matchesOne(selPreprint, preprintVal);

            return okPreprint;
        });

        // --- DataTables update 
        const dt = this.dtPubsStandalone;
        if (!dt) return;

        dt.clear();
        dt.rows.add(filteredTable as any);
        dt.draw(false);

        this.updatePubsCount();
        // chart = filtered table state.
        this.pubChartPendingRows = filteredTable;

       // if (this.pubChartVisible) {
          //  this.renderPubChartFromZero(filteredTable);
       // }
    }


    // ==============================
    // Publication Refresh 
    // ==============================

    private pubsRefreshInited = false;

    private wirePublicationsRefresh(): void {
        if (this.pubsRefreshInited) return;

        const btn = document.getElementById('pubs-refresh');
        const url =
            btn?.getAttribute('data-refresh-url') ||

            //Json refresh---------

            (window.location.pathname + '?handler=PublicationsJson');

        $('#pubs-refresh').off('click').on('click', async () => {
            try {
                // Hide filters+table, disable keys, show loading
                this.setPubsLoading(true);
               
                await new Promise(requestAnimationFrame);

                const res = await fetch(url, {
                    method: 'GET',
                    headers: { Accept: 'application/json' },
                    credentials: 'same-origin',
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);

                const payload = await res.json();
                //update timestamp div
                const el = document.getElementById('pubs-last-updated');
                const lastUtc = payload?.publicationsLastUpdatedUtc ?? payload?.PublicationsLastUpdatedUtc;

                if (el && lastUtc) {
                    el.textContent = this.formatLocalRazorStyle(new Date(lastUtc));
                    el.classList.remove('d-none');
                }

                const pubs = (payload?.Publications ?? payload?.publications ?? []) as any[];

                const rows: PubDtRow[] = this.mapToPubDtRows(pubs);

                this.pubsRowsAll = rows;

                this.rebuildPubsIndex(this.pubsRowsAll);


                // Rebuild dropdown options from new data
                this.pubsFiltersInited = false;
                this.buildPublicationsFilters();

                // Push to DT (draw + update count)
                this.applyPublicationsFilters();

                requestAnimationFrame(() => {
                    try { this.dtPubsStandalone?.columns.adjust(); } catch { }
                    try { ($('#pubs-filter-container .selectpicker') as any).selectpicker('refresh'); } catch { }
                });



            } catch (e) {
                console.error('[PUBS] AJAX refresh failed', e);
                alert('Refresh failed. Check console for details.');
            } finally {
                // Show filters + table again
                this.setPubsLoading(false);
            }
        });

        this.pubsRefreshInited = true;
    }

    private setPubsLoading(isLoading: boolean): void {
        $('#pubs-loading').toggleClass('d-none', !isLoading);
        $('#pubs-body').toggleClass('d-none', isLoading);

        // Hide count + disable buttons while loading
        $('#pubs-count').toggleClass('d-none', isLoading);
        $('#pubs-reset').prop('disabled', isLoading);
        $('#pubs-refresh').prop('disabled', isLoading);
        $('#pubs-refresh').prop('isloading', isLoading);
    }


    // ==============================
    // Pub Row trigger Modal
    // ==============================

    private pubsRowActionsInited = false;

    private wirePublicationsRowActions(): void {
        if (this.pubsRowActionsInited) return;


        $(document)
            .off('click', 'a.pub-title-link')
            .on('click', 'a.pub-title-link', (e) => {
                e.preventDefault();

                const key = String((e.currentTarget as HTMLElement).getAttribute('data-pubkey') || '').trim();
                const vm = this.pubsIndex.get(key);

                const $modal = $('#pub-detail-modal');
                if (!vm) {
                    $modal.find('.modal-body').prepend('<div class="alert alert-danger">Publication not found.</div>');
                    $modal.modal('show');
                    return;
                }
                $modal.find('.alert').remove();

                this.fillPubModal(vm);
                $modal.modal('show');

            });

        this.pubsRowActionsInited = true;
    }

    private fillPubModal(p: PubDtRow): void {
        const $modal = $('#pub-detail-modal');

        const setText = (sel: string, val?: string | null) => {
            const $el = $modal.find(sel);
            const v = (val ?? '').trim();
            $el.text(v || EmptyDisplay);
        };

        const setPills = (sel: string, items?: string[] | string | null) => {
            const $el = $modal.find(sel);
            const arr =
                Array.isArray(items) ? items :
                    (typeof items === 'string' ? items.split(/;|,/g) : []);
            this.renderPills($el, arr.map(x => String(x ?? '').trim()).filter(Boolean));
        };

        const pillsCount = (sel: string): number => $modal.find(sel).find('span').length;

        // -----------------------------
        // Header
        // -----------------------------
        setText('[data-pub="Title"]', p.Title);

        // "Last Updated:" / date line
        setText('[data-pub="PubDate"]', p.PublicationDateDisplay || p.PublicationDateUtc || '');

        // -----------------------------
        // Block 1: Center, Publication Status, Journal
        // -----------------------------
        const MISSING_CENTER_MSG =
            'No center was detected for this publication. Missing ReVAMPP Award Number in PubMed.';

        const centers = (p.CenterNames ?? []).map(x => String(x ?? '').trim()).filter(Boolean);
        const $centersHost = $modal.find('[data-pub="Centers"]');

        // Clear whatever was there
        $centersHost.empty().removeClass('d-none');

        if (centers.length) {
            // Normal case: show pills
            this.renderPills($centersHost, centers);
        } else {
            // Empty center: show warning text (NOT a pill)
            $centersHost.html(`
    <div class="text-warning font-italic">
      ${_.escape(MISSING_CENTER_MSG)}
    </div>
  `);
        }
        // Always show a status pill: Preprint OR Published
        const status = p.IsPreprint ? 'Preprint' : 'Published'; setPills('[data-pub="PublicationStatus"]',
            [status]); $modal.find('[data-pub="PublicationStatus"]').toggleClass('d-none', pillsCount('[data-pub="PublicationStatus"]') === 0);
        // Journal 
        const journal = (p.Journal ?? '').trim();
        setText('[data-pub="Journal"]', journal);
        $modal.find('#pub-journal-block').toggleClass('d-none', !journal);


        // -----------------------------
        // Block 2: Authors
        // -----------------------------
        const authors = (p.Authors ?? '').trim();
        setText('[data-pub="Authors"]', authors);
        $modal.find('#pub-authors-block').toggleClass('d-none', !authors);

        // -----------------------------
        // Abstract (hide label/section when empty)
        // -----------------------------
        const absRaw = (p.Abstract ?? '').trim();

        const $absPrev = $modal.find('[data-pub="AbstractPreview"]');
        const $absFull = $modal.find('[data-pub="AbstractFull"]');
        const $absBtn = $modal.find('#pub-abstract-toggle');

        $absBtn.off('click');

        const hasAbstract = !!absRaw;
        $modal.find('#pub-abstract-label, #pub-abstract-section')
            .toggleClass('d-none', !hasAbstract);

        if (!hasAbstract) {
            $absPrev.html(EmptyDisplay);
            $absFull.html('').addClass('d-none');
            $absBtn.addClass('d-none').text('Read full abstract');
        } else {
            const plain = absRaw.replace(/<br\s*\/?>/gi, '\n');
            const limit = 650;
            const needsToggle = plain.length > limit;

            const previewPlain = needsToggle ? plain.slice(0, limit).trim() + '…' : plain;

            const toHtml = (txt: string) =>
                txt
                    .replace(/<br\s*\/?>/gi, '\n')
                    .split('\n')
                    .map(s => _.escape(s))
                    .join('<br>');

            $absPrev.html(toHtml(previewPlain)).toggleClass('d-none', false);
            $absFull.html(toHtml(absRaw)).addClass('d-none');

            if (needsToggle) {
                $absBtn.removeClass('d-none').text('Read full abstract');
                $absBtn.on('click', () => {
                    const expanded = !$absFull.hasClass('d-none');
                    $absFull.toggleClass('d-none', expanded);
                    $absPrev.toggleClass('d-none', !expanded);
                    $absBtn.text(expanded ? 'Read full abstract' : 'Show less');
                });
            } else {
                $absBtn.addClass('d-none').text('Read full abstract');
            }
        }

        // -----------------------------
        // Identifiers
        // -----------------------------
        const pmid = (p.PubMedId ?? '').trim();
        const doi = (p.Doi ?? '').trim();
        const pmcid = (p.Pmcid ?? '').trim();

        const $pmidWrap = $modal.find('#pub-id-pmid');
        const $pmcidWrap = $modal.find('#pub-id-pmcid');
        const $doiWrap = $modal.find('#pub-id-doi');

        const $pmidA = $modal.find('[data-pub="PmidLink"]');
        const $pmcidA = $modal.find('[data-pub="PmcidLink"]');
        const $doiA = $modal.find('[data-pub="DoiLink"]');

        $pmidWrap.toggleClass('d-none', !pmid);
        $pmidA.text(pmid);
        if (pmid) $pmidA.attr('href', `https://pubmed.ncbi.nlm.nih.gov/${encodeURIComponent(pmid)}/`);
        else $pmidA.removeAttr('href');

        $pmcidWrap.toggleClass('d-none', !pmcid);
        $pmcidA.text(pmcid);
        if (pmcid) $pmcidA.attr('href', `https://pmc.ncbi.nlm.nih.gov/articles/${encodeURIComponent(pmcid)}/`);
        else $pmcidA.removeAttr('href');

        $doiWrap.toggleClass('d-none', !doi);
        $doiA.text(doi);
        if (doi) $doiA.attr('href', `https://doi.org/${encodeURIComponent(doi)}`);
        else $doiA.removeAttr('href');

        const hasIds = !!(pmid || pmcid || doi);
        $modal.find('#pub-ids-label, #pub-ids-section').toggleClass('d-none', !hasIds);

        // Footer PubMed button
        const $pubmedLink = $modal.find('#pub-pubmed-link');
        if (pmid) $pubmedLink.attr('href', `https://pubmed.ncbi.nlm.nih.gov/${encodeURIComponent(pmid)}/`).removeClass('d-none');
        else $pubmedLink.attr('href', '#').addClass('d-none');
    }

    // Added for Publication refresh table timestamp

    private formatLocalRazorStyle(d: Date): string {
        if (!d || isNaN(d.getTime())) return '';
        return `${FormatDate(d, "day-mo-year")}`;
    }

    // Warning for missing award number and center column tooltip

    private wireSimpleTooltips(): void {
        const tip = document.getElementById('simple-tooltip');
        if (!tip) return;

        const show = (el: HTMLElement) => {
            const msg = el.getAttribute('data-tooltip') || '';
            if (!msg.trim()) return;
            tip.textContent = msg;
            tip.classList.remove('d-none');
        };

        const hide = () => tip.classList.add('d-none');

        const position = (clientX: number, clientY: number) => {
            // offset from cursor
            const pad = 12;
            let x = clientX + pad;
            let y = clientY + pad;

            // keep on-screen
            const rect = tip.getBoundingClientRect();
            const vw = window.innerWidth;
            const vh = window.innerHeight;

            if (x + rect.width > vw - 8) x = vw - rect.width - 8;
            if (y + rect.height > vh - 8) y = vh - rect.height - 8;

            tip.style.left = `${x}px`;
            tip.style.top = `${y}px`;
        };

        // Delegated events (works with DT redraw + FixedColumns clones)
        document.addEventListener('mouseenter', (e) => {
            const el = (e.target as HTMLElement)?.closest?.('.js-tip') as HTMLElement | null;
            if (!el) return;
            show(el);
        }, true);

        document.addEventListener('mousemove', (e) => {
            if (tip.classList.contains('d-none')) return;
            position((e as MouseEvent).clientX, (e as MouseEvent).clientY);
        }, true);

        document.addEventListener('mouseleave', (e) => {
            const el = (e.target as HTMLElement)?.closest?.('.js-tip');
            if (!el) return;
            hide();
        }, true);

        // safety: hide on scroll/click
        document.addEventListener('scroll', hide, true);
        document.addEventListener('click', hide, true);

    }

  
    //============================ 
    // CHART of PUBLICATIONS 
    //============================ 

    private msChart?: Highcharts.Chart;
    private pubChartVisible = false;
    private pubChartPendingRows?: PubDtRow[];


    private computePubChart(rows?: PubDtRow[]) {
        const data = rows ?? this.pubsRowsAll ?? [];
        const UNKNOWN_LABEL = 'Unknown';

        const normalizeCenter = (c: string) => {
            const v = (c ?? '').trim();
            if (!v) return UNKNOWN_LABEL;
            return v === MISSING_CENTER_LABEL ? UNKNOWN_LABEL : v;
        };

        const centerSet = new Set<string>();

        // centers from publications rows
        data.forEach(p => {
            const cs = (p.CenterNames?.length ? p.CenterNames : [UNKNOWN_LABEL]).map(normalizeCenter);
            cs.forEach(c => centerSet.add(c));
        });

        // centers from in-progress map
        Object.keys(this.inProgressMsByCenter ?? {}).forEach(k => centerSet.add(normalizeCenter(k)));

        const centers = Array.from(centerSet).sort((a, b) => a.localeCompare(b));

        const published = new Map<string, number>();
        const preprint = new Map<string, number>();
        const inc = (m: Map<string, number>, k: string) => m.set(k, (m.get(k) ?? 0) + 1);

        data.forEach(p => {
            const cs = (p.CenterNames?.length ? p.CenterNames : [UNKNOWN_LABEL])
                .map(normalizeCenter)
                .filter(Boolean);

            cs.forEach(c => (p.IsPreprint ? inc(preprint, c) : inc(published, c)));
        });

        const inprog = centers.map(c => this.inProgressMsByCenter?.[c] ?? 0);

        return {
            centers,
            pre: centers.map(c => preprint.get(c) ?? 0),
            pub: centers.map(c => published.get(c) ?? 0),
            inprog
        };
    }


     /*private pubChart?: Highcharts.Chart;

   private renderPubChartFromZero(rows?: PubDtRow[]) {
        const el = document.getElementById('pub-status-by-center-chart');
        if (!el) return;

        const { centers, pre, pub, inprog } = this.computePubChart(rows);

        const PREPRINT_COLOR = '#11416c';
        const PUBLISHED_COLOR = '#05af55';
        const INPROG_COLOR = '#fcb316'; 

        const zeros = centers.map(() => 0);

        this.msChart?.destroy();
        this.msChart = undefined;

        this.msChart = Highcharts.chart('pub-status-by-center-chart', {
            chart: { type: 'bar', animation: true },
            title: { text: null as any },
            credits: { enabled: false },

            yAxis: { min: 0, title: { text: 'Count' }, allowDecimals: false },
            xAxis: { categories: centers },

            plotOptions: {
                series: {
                    stacking: 'normal',
                    animation: { duration: 650 },
                    dataLabels: { enabled: false }
                }
            },

            tooltip: { shared: true },

            series: [
                { name: 'Preprint', type: 'bar', data: zeros, color: PREPRINT_COLOR, stack: 'pubs' },
                { name: 'Published', type: 'bar', data: zeros, color: PUBLISHED_COLOR, stack: 'pubs' },
                { name: 'In Progress', type: 'bar', data: zeros, color: INPROG_COLOR, stack: 'ms' }
            ]
        });

        requestAnimationFrame(() => {
            if (!this.msChart) return;
            this.msChart.reflow();

            this.msChart.series[0].setData(pre, false, { duration: 700 });
            this.msChart.series[1].setData(pub, false, { duration: 700 });
            this.msChart.series[2].setData(inprog, false, { duration: 700 });

            this.msChart.redraw();
        });
    }


   

    private wireMsChartToggle(): void {

        const $collapse = $('#pub-status-chart-collapse');

        this.pubChartVisible = $collapse.hasClass('show');
            $collapse

            .on('shown.bs.collapse', () => {

                this.pubChartVisible = true;
                $('.pub-chart-toggle-text').text('Hide chart');
                $('.pub-chart-toggle-icon').removeClass('fa-caret-down').addClass('fa-caret-up');

                // Build fresh chart and animate from zero 
                const rows = this.pubChartPendingRows ?? this.pubsRowsAll;
                this.renderPubChartFromZero(rows);

            })

            .on('hidden.bs.collapse', () => {

                this.pubChartVisible = false;
                $('.pub-chart-toggle-text').text('Show chart');
                $('.pub-chart-toggle-icon').removeClass('fa-caret-up').addClass('fa-caret-down');

                // Destroy so next open always grows 
                this.msChart?.destroy();
                this.msChart = undefined;

            });

        $(document).off('click.pubChart').on('click.pubChart', '.pub-chart-toggle', () => {

            $('.chart-icon').toggleClass('green');

        });

    } 
 */
}
